// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as Icon$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";

function VideoPlaybackModal(Props) {
  var link = Props.link;
  var close_modal = Props.close_modal;
  var show_modalOpt = Props.show_modal;
  var show_modal = show_modalOpt !== undefined ? show_modalOpt : false;
  return React.createElement(ReactModal, {
              isOpen: show_modal,
              onRequestClose: (function (param) {
                  return Curry._1(close_modal, undefined);
                }),
              overlayClassName: "video-overlay",
              className: "video-modal",
              ariaHideApp: false,
              children: React.createElement("div", {
                    className: "score-info-video"
                  }, React.createElement("div", {
                        className: "score-info-video-close-btn",
                        onClick: (function (param) {
                            return Curry._1(close_modal, undefined);
                          })
                      }, React.createElement(Icon$Catalyst.CloseIcon.make, {})), React.createElement("iframe", {
                        autoPlay: true,
                        preload: "metadata",
                        src: link
                      }))
            });
}

var make = VideoPlaybackModal;

export {
  make ,
  
}
/* react Not a pure module */
